import React from 'react';
import Grid from '@material-ui/core/Grid';
import {AccentColorOptions} from 'epic-ue-theme';
import {GridContainer, VerticalSpacer} from '../../elements';
import {LineTextBlock} from '../../elements/text';
import {CommunityGalleryCards, CommunityGalleryCardOptionsArray} from './CommunityGallery.cards';
import {CommunityGalleryWrapper, SliderWrapper} from './CommunityGallery.styles';
import {AnimateOnViewWrap, Spotlight} from '../../wraps';
import {useCommunitySpotlightImage} from './CommunityGallery.hooks';

export interface CommunityGalleryProps {
    accentColor?: AccentColorOptions;
    title?: string;
    href?: string;
    className?: string;
    cards?: CommunityGalleryCardOptionsArray;
    callToAction?: string;
    topSpacing?: boolean;
    hidden?: boolean;
}

export const CommunityGallery = (props: CommunityGalleryProps): JSX.Element | null => {
    const {
        accentColor = 'forest',
        title,
        href,
        className,
        cards = [],
        callToAction = 'Visit Community',
        topSpacing = true,
        hidden = false
    } = props;

    const {communitySpotlightImage} = useCommunitySpotlightImage();

    if (hidden) return null;

    const firstCard = cards[0] || {};
    const isImageWrap = firstCard.imageWrap;

    return (
        <CommunityGalleryWrapper className={className}>
            <Spotlight disable={!isImageWrap} image={communitySpotlightImage}>
                <GridContainer>
                    {topSpacing && <VerticalSpacer variant="custom" spacing={16} />}
                    <LineTextBlock
                        headline={title}
                        button={{label: callToAction, href, type: 'tertiary'}}
                        hideHR
                        accentColor={accentColor}
                        className={'gallery-heading'}
                    />
                    <Grid container direction="row" wrap="nowrap">
                        <Grid item xs={12}>
                            <AnimateOnViewWrap translateY={30}>
                                <SliderWrapper accentcolor={accentColor}>
                                    <CommunityGalleryCards dynamicPageDataArray={cards} />
                                </SliderWrapper>
                            </AnimateOnViewWrap>
                        </Grid>
                    </Grid>
                    <VerticalSpacer variant="custom" spacing={16} />
                </GridContainer>
            </Spotlight>
        </CommunityGalleryWrapper>
    );
};
